import {AthubRestResource} from "@/api/rest";
import {DCIM_SERVER} from "@/api";
import athubAxios from "@/util/athub-axios/core";

const pointProperty = new AthubRestResource({server: DCIM_SERVER, resource: 'point-property'});

pointProperty.getRowProperties = (rowId, config) => {
    return pointProperty.handlePromise(
        athubAxios.get(`${pointProperty.server}/${pointProperty.resource}/property-value/row-id/${rowId}`,
            config));
};

export default pointProperty;
